import { render, staticRenderFns } from "./header_area.vue?vue&type=template&id=26456534"
import script from "./header_area.vue?vue&type=script&lang=js"
export * from "./header_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports